import BaseStore from "@/v1/utils/BaseStore";

import {
  GET_ATTRIBUTE_COLLECTION_START,
  GET_ATTRIBUTE_COLLECTION_SUCCESS,
  GET_COLLECTION_TYPES_START,
  GET_COLLECTION_TYPES_SUCCESS,
  GET_DETAIL_COLLECTION_START,
  GET_DETAIL_COLLECTION_SUCCESS,
  GET_TYPES_FAMILY_START,
  GET_TYPES_FAMILY_SUCCESS,
} from "./types";

const initialState = {
  loading: false,
  detail: {
    attribute_types: [],
    loading: false,
    id: null,
    name: "",
    source: "",
    status: "",
  },
};

const store = new BaseStore("attributeCollection", initialState);

const reducerSuccessTypesHandler = (state, payload) => ({
  ...state,
  detail: {
    ...state.detail,
    attribute_types: payload.attribute_types,
    loading: false,
  },
});

const reducerGetTypesHandler = state => ({
  ...state,
  detail: {
    ...state.detail,
    attribute_types: [],
    loading: true,
  },
});

const reducer = {
  [GET_ATTRIBUTE_COLLECTION_START]: state => ({
    ...state,
    results: [],
    loading: true,
  }),
  [GET_ATTRIBUTE_COLLECTION_SUCCESS]: (state, payload) => ({
    ...state,
    ...payload,
    loading: false,
  }),
  [GET_DETAIL_COLLECTION_START]: state => ({
    ...state,
    detail: {
      ...state.detail,
      loading: true,
    },
  }),
  [GET_DETAIL_COLLECTION_SUCCESS]: (state, payload) => ({
    ...state,
    detail: {
      ...state.detail,
      ...payload.detail,
      loading: false,
    },
  }),
  [GET_COLLECTION_TYPES_START]: reducerGetTypesHandler,
  [GET_COLLECTION_TYPES_SUCCESS]: reducerSuccessTypesHandler,
  [GET_TYPES_FAMILY_START]: reducerGetTypesHandler,
  [GET_TYPES_FAMILY_SUCCESS]: reducerSuccessTypesHandler,
};

export default store.reducer(reducer);
